import React, { createContext } from "react";
import { PermissionType } from "../utils/adminPermissions";

interface AdminPermissionContextType {
  hasAccess: (moduleKey: string) => boolean;
  canWrite: (moduleKey: string) => boolean;
  getPermission: (moduleKey: string) => PermissionType;
  moduleKey: string;
  isReadOnly: boolean;
}

export const AdminPermissionContext = createContext<AdminPermissionContextType | undefined>(
  undefined
);

export const useAdminModulePermission = () => {
  const context = React.useContext(AdminPermissionContext);
  if (!context) {
    throw new Error(
      "useAdminModulePermission debe usarse dentro de ProtectedAdminPage"
    );
  }
  return context;
};
